import React from 'react';
import { Button as AntdButton, ButtonProps } from 'antd';
import style from './button.module.scss';
import clsx from 'clsx'

interface CustomButtonProps extends ButtonProps {
  className?: string;
  variantButton?: 'default' | 'outline'
}

export const Button: React.FC<CustomButtonProps> = ({ className = '', variantButton = 'default', children, ...props }) => {
  return (
    <AntdButton
      type={variantButton === 'default' ? 'primary' : undefined}
      className={clsx(
        style.button,
        {
          [style.default]: variantButton === 'default',
          [style.outline]: variantButton === 'outline',
        },
        className
      )}
      {...props}
    >
      {children}
    </AntdButton>
  );
};
